import React from 'react'
import { Link } from 'react-router-dom'
import AboutImg from '../../assets/images/Contact us.png'
function Bredcom({ head, title, sbtitle }) {
  return (
    <>
      <section className="page-header" style={{
        backgroundImage: `url('${AboutImg}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '400px',
        width: '100%',
        position: 'relative'
      }} >
        <div className="page-header__bg" />
        <div className="container">
          <h2 className="page-header__title">{head}</h2>
          <ul className="list-unstyled breadcrumb-one">
            <li>
              <Link to="/">{title}</Link>
            </li>
            <li>
              <span>{sbtitle}</span>
            </li>
          </ul>
        </div>
      </section>
    </>
  )
}

export default Bredcom